// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import faceFrownIcon from "@/assets/icons/face-frown.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FaceFrownIconProps = Omit<IconProps, "name">;

export function FaceFrownIcon(props: FaceFrownIconProps): React.ReactNode {
  return <Icon name={faceFrownIcon} {...props} />;
}
